import React, { useRef, useState } from 'react';
import UploadIcon from 'assets/img/campanhas-de-marketing/nova-campanha/icon-upload.svg';
import DocumentIcon from 'assets/img/campanhas-de-marketing/nova-campanha/icon-document.svg';
import TrashIcon from 'assets/img/campanhas-de-marketing/nova-campanha/icon-trash.svg';
import { CampaignFileInputProps } from 'models/campaign-mkt';
import ErrorMessage from '../errorMessage/errorMessage';
import * as S from './styles';

const INVALID_FILE_MESSAGE =
  'Arquivo inválido. Envie um arquivo no formato .CSV ou .XLSX.';

const FileInput = ({
  file,
  fileError,
  progress = 0,
  setFile,
  setFileError,
  uploading = false,
}: CampaignFileInputProps): JSX.Element => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [displayFile, setDisplayFile] = useState<File>();
  const [fileErrorMessage, setFileErrorMessage] = useState('');

  const validExtensions = ['csv', 'xlsx'];
  const selectedFile = displayFile || file;

  const rejectFile = (message: string): void => {
    setDisplayFile(undefined);
    setFile(undefined);
    setFileError(true);
    setFileErrorMessage(message);
  };

  const checkValidFile = (fileData?: File): void => {
    if (!fileData) return;

    setDisplayFile(undefined);
    setFile(undefined);
    setFileError(false);
    setFileErrorMessage('');

    const extension = fileData.name.split('.').pop()?.toLowerCase() || '';
    const valid = validExtensions.indexOf(extension) >= 0;

    if (inputRef.current) inputRef.current.value = '';

    if (!valid) {
      rejectFile(INVALID_FILE_MESSAGE);
      return;
    }

    setDisplayFile(fileData);
    setFile(fileData);
    setFileError(false);
  };

  const removeFile = () => {
    setDisplayFile(undefined);
    setFile(undefined);
    setFileError(false);
    setFileErrorMessage('');
    if (inputRef.current) inputRef.current.value = '';
  };

  return (
    <>
      <S.UploadCard $error={fileError}>
        <S.HiddenInput
          accept=".csv,.xlsx,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          id="campaign-file-input"
          onChange={(event) => checkValidFile(event.target.files?.[0])}
          ref={inputRef}
          type="file"
        />
        <S.UploadLabel htmlFor="campaign-file-input">
          <S.FileIcon
            $selected={Boolean(selectedFile)}
            src={selectedFile ? DocumentIcon : UploadIcon}
            alt=""
          />
          <S.UploadContent>
            <strong>Envie seu arquivo da listagem</strong>
            {selectedFile ? (
              <S.FileDetails>
                <S.FileName>{selectedFile.name}</S.FileName>
                {!fileError && (uploading || progress > 0) && (
                  <S.FileProgress $complete={progress >= 100}>
                    {`${progress}%`}
                  </S.FileProgress>
                )}
                {!fileError && uploading && progress < 100 && (
                  <S.ProgressSpinner />
                )}
              </S.FileDetails>
            ) : (
              <span>Formatos aceitos: XLSX ou CSV</span>
            )}
          </S.UploadContent>
        </S.UploadLabel>
        {selectedFile && (
          <S.RemoveButton
            aria-label="Remover arquivo"
            disabled={uploading}
            onClick={removeFile}
            type="button"
          >
            <img src={TrashIcon} alt="" />
          </S.RemoveButton>
        )}
      </S.UploadCard>
      {fileError && (
        <ErrorMessage>{fileErrorMessage || INVALID_FILE_MESSAGE}</ErrorMessage>
      )}
    </>
  );
};

export default FileInput;
